import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class CashDesk extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            fromAutoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            onSetCashDesk: this.isNull(props.OnSetCashDesk) ? null : props.OnSetCashDesk,
            callbackData: this.isNull(props.CallbackData) ? null : props.CallbackData,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/cashdesk/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save() {
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;
        
        this.httpPost("api/v1/cashdesk/save", {
            id: this.getCurrentFormId(),
            organizationId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            groupId: this.state.data.record.groupId,
            code: parseInt(this.state.data.record.code),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");

                    if (this.state.fromAutoComplete) {
                        if (this.isNull(this.state.onSetCashDesk)) {
                            this.state.caller.setCashDesk({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            });
                        }
                        else {
                            this.state.onSetCashDesk({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            }, this.state.caller, this.state.callbackData);
                        }
                    }
                    else
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات صندوق" : "افزودن صندوق جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-10">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان </label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">تفصیل</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="40" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف </button>
                            <button type="submit" onClick={e=>this.save()} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}